import { ReportType } from '../types'

/**
 * Human-readable titles for each report type
 */
export const reportTitles: Record<ReportType, string> = {
  uploadedDiagnosis: 'Uploaded diagnosis document',
  missingEmergencyContact: 'Missing Emergency Contact',
}

/**
 * Report types that require start/end date selection
 */
export const DATE_REQUIRED_REPORTS = new Set<ReportType>(['uploadedDiagnosis'])
